import React from "react";
import resume from "../../assets/docs/Noor Mohammad resume.pdf";

const Footer = ({ theme }) => {
  return (
    <div
      className={`${
        theme === "dark" ? "border-darkLineColor" : "border-lightLineColor"
      } py-6 border-t-[1px] max-w-6xl px-10 xl:px-0 mx-auto`}
    >
      <div className="text-gray-200 flex items-center justify-between">
        <div>
          <a href="https://reactbd.com/" target="_blank" rel="noreferrer">
            <p
              className={`${
                theme === "dark"
                  ? "text-[#BEDBFE] border-darkLineColor"
                  : "text-lightTextColor border-lightLineColor"
              } text-sm `}
            >
              © 2022 <span>reactBD</span> All rights reserved.
            </p>
          </a>
        </div>
        <div>
          <a href={resume} target="_blank" rel="noreferrer">
            <p
              className={`${
                theme === "dark"
                  ? "text-[#BEDBFE]  border-lightLineColor"
                  : "text-lightTextColor border-darkLineColor"
              } text-sm font-bodyFont border-b`}
            >
              View resume
            </p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
